import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
}

import pathToRegexp from 'path-to-regexp'
import { onMounted, reactive, watch } from "vue";
import { useRoute, RouteLocationMatched } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
let obj = reactive({ levelList: {} })
// 获取面包屑
const getBreadcrumb = () => {
  let matched:Array<RouteLocationMatched> = route.matched.filter(item => item.meta && item.meta.title)
  obj.levelList= matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
}

onMounted(() => {
  getBreadcrumb()
  watch(route, () => {
    if (route.path.startsWith('/redirect/')) {
      return
    }
    getBreadcrumb()
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "app-breadcrumb",
    separator: "/"
  }, {
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(obj).levelList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withCtx(() => [
                (item.redirect === 'noRedirect' || index == _unref(obj).levelList.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})